import { render, staticRenderFns } from "./customRadio.vue?vue&type=template&id=c72b4bae&scoped=true&"
import script from "./customRadio.vue?vue&type=script&lang=js&"
export * from "./customRadio.vue?vue&type=script&lang=js&"
import style0 from "./customRadio.vue?vue&type=style&index=0&id=c72b4bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72b4bae",
  null
  
)

export default component.exports